<div class="!pr-[40px] !mb-[60px] flex">
  <div class="!w-[90%]">
    <div class="h-auto">
      <div class="container flex !pt-[15px]">
        <h3 class="!text-[20px] !text-[#000000] !font-bold !pl-[20px]">
          LIST OF SUBMISSIONS
        </h3>
      </div>
    </div>

    <app-filter-tool></app-filter-tool>

    <table class="w-full bg-[#fcfcfd] table-auto !mt-[20px]">
      <thead
        class="h-[52px] bg-[#DEE2E6] text-[#000000] !text-center justify-center !p-[20px]"
      >
        <tr>
          <th class="px-4 text-left w-[160px] header-field">RFI No.</th>
          <th class="px-4 text-left w-auto header-field">Title</th>
          <th
            class="px-4 text-left w-auto header-field"
            style="text-align: center"
          >
            Issued
          </th>
          <th
            class="px-4 text-left w-auto header-field"
            style="text-align: center"
          >
            Response Date
          </th>
          <th class="px-4 text-left w-auto header-field">Subject</th>
          <th class="px-4 text-left w-auto header-field">Status</th>
          <th class="px-4 text-center w-auto header-field">Action</th>
        </tr>
      </thead>
      <tbody class="!text-center">
        <ng-container *ngFor="let rfi of tableData; let i = index">
          <tr
            class="hover:bg-[#fae8e1] border-b-0"
            [ngClass]="{ 'bg-white': i % 2 === 0, 'bg-[#DEE2E6]': i % 2 !== 0 }"
          >
            <td
              class="border-b-0 pr-4 pl-[1rem] py-2 w-auto cursor-pointer text-left whitespace-nowrap"
              (click)="openView(rfi?.id)"
            >
              {{ this.projectIdentifier }} {{ rfi?.rfi_no }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto cursor-pointer text-left">
              {{
                rfi?.title.length > 25
                  ? (rfi?.title | slice : 0 : 25) + "..."
                  : rfi?.title
              }}
            </td>
            <td
              class="border-b-0 px-4 py-2 w-auto cursor-pointer text-left"
              style="text-align: center"
            >
              {{ rfi?.issue_date }}
            </td>
            <td
              class="border-b-0 px-4 py-2 w-auto text-left"
              style="text-align: center"
            >
              {{ rfi?.response_date }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{
                rfi?.subject.length > 25
                  ? (rfi?.subject | slice : 0 : 25) + "..."
                  : rfi?.subject
              }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ rfi?.status }}
            </td>
            <!-- DropDown Menu -->
            <td class="border-b-0 px-4 py-2 w-auto cursor-pointer text-center">
              <button mat-button [matMenuTriggerFor]="menu">
                <mat-icon class="text-[#000000]">more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item [disabled]="rfi?.is_initiated === 1">
                  <mat-icon style="color: #2196f3; font-size: 24px !important"
                    >edit</mat-icon
                  >
                  <span style="margin-left: 10px">Edit</span>
                </button>

                <button mat-menu-item (click)="openView(rfi?.id)">
                  <mat-icon style="color: #4caf50; font-size: 24px !important"
                    >visibility</mat-icon
                  >
                  <span style="margin-left: 10px">View Details</span>
                </button>
              </mat-menu>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div class="ml-auto flex !mt-[20px]">
    <button
      (click)="handleCreateRfi()"
      class="!bg-[#E76B3F] !text-[#ffffff] !text-[14px] flex h-[38px] w-[120px] items-center flex-shrink-0 hover:bg-white rounded-[3px] shadow-md ml-[15px] text-center"
      style="padding: 14px 10px; font-weight: 700"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clip-path="url(#clip0_5810_47932)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 0C5.38125 0 0 5.38125 0 12C0 18.6187 5.38125 24 12 24C18.6187 24 24 18.6187 24 12C24 5.38125 18.6187 0 12 0Z"
            fill="#E76B3F"
          />
          <path
            d="M5.4375 13.107V10.8898C5.4375 10.6648 5.62031 10.4773 5.85 10.4773H10.4859V5.84609C10.4859 5.62109 10.6687 5.43359 10.8984 5.43359H13.1156C13.3406 5.43359 13.5234 5.61641 13.5234 5.84609V10.482H18.1547C18.3797 10.482 18.5672 10.6648 18.5672 10.8945V13.1117C18.5672 13.3367 18.3844 13.5195 18.1547 13.5195H13.5187V18.1508C13.5187 18.3758 13.3359 18.5633 13.1109 18.5633H10.8937C10.6687 18.5633 10.4813 18.3805 10.4813 18.1508V13.5148H5.85C5.62031 13.5195 5.4375 13.332 5.4375 13.107Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_5810_47932">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      Create RFI
    </button>
  </div>
</div>

<app-add-rfi
  [isDialogOpen]="isDialogOpen"
  (loadRfiData)="loadRfiData()"
></app-add-rfi>
